"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HarvestTimeEntryAggregator = void 0;
class HarvestTimeEntryAggregator {
    constructor() {
        this.aggregated = {
            total: 0,
            billable: 0,
            budgeted: 0,
        };
    }
    add(entry) {
        this.aggregated.total += entry.hours;
        if (entry.billable) {
            this.aggregated.billable += entry.hours;
        }
        if (entry.budgeted) {
            this.aggregated.budgeted += entry.hours;
        }
    }
}
exports.HarvestTimeEntryAggregator = HarvestTimeEntryAggregator;
//# sourceMappingURL=HarvestTimeEntryAggregator.js.map